(() => {
  const DESKTOP_QUERY = '(min-width: 750px)';

  const enhanceGallery = (gallery) => {
    if (gallery.dataset.immershopGalleryEnhanced === 'true') return;

    const viewer = gallery.querySelector('[id^="GalleryViewer-"]');
    const list = viewer?.querySelector('[id^="Slider-Gallery-"]');
    const controls = viewer?.querySelector('.immershop-gallery-controls');
    const previous = controls?.querySelector('[data-immershop-gallery-previous]');
    const next = controls?.querySelector('[data-immershop-gallery-next]');
    const current = controls?.querySelector('.slider-counter--current');
    const total = controls?.querySelector('.slider-counter--total');

    if (!viewer || !list || !controls || !previous || !next || !current || !total) return;

    gallery.dataset.immershopGalleryEnhanced = 'true';
    const mediaQuery = window.matchMedia(DESKTOP_QUERY);

    const items = () =>
      Array.from(list.querySelectorAll('[data-media-id]')).filter((item) =>
        gallery.querySelector(`[data-target="${item.dataset.mediaId}"]`)
      );
    const getDesktopActiveIndex = () => Math.max(0, items().findIndex((item) => item.classList.contains('is-active')));
    const getMobileActiveIndex = () => {
      const galleryItems = items();
      if (galleryItems.length < 2) return 0;
      const step = galleryItems[1].offsetLeft - galleryItems[0].offsetLeft;
      return step > 0 ? Math.min(galleryItems.length - 1, Math.max(0, Math.round(list.scrollLeft / step))) : 0;
    };

    const syncControls = () => {
      const galleryItems = items();
      const activeIndex = mediaQuery.matches ? getDesktopActiveIndex() : getMobileActiveIndex();
      const isDesktop = mediaQuery.matches;

      current.textContent = String(activeIndex + 1);
      total.textContent = String(galleryItems.length);
      previous.disabled = !isDesktop || activeIndex === 0;
      next.disabled = !isDesktop || activeIndex === galleryItems.length - 1;
      controls.toggleAttribute('data-single-media', galleryItems.length <= 1);
    };

    const move = (direction) => {
      if (!mediaQuery.matches) return;

      const galleryItems = items();
      const nextIndex = getDesktopActiveIndex() + direction;
      const nextItem = galleryItems[nextIndex];
      if (!nextItem || typeof gallery.setActiveMedia !== 'function') return;

      gallery.setActiveMedia(nextItem.dataset.mediaId, false);
      window.requestAnimationFrame(syncControls);
    };

    previous.addEventListener('click', (event) => {
      if (!mediaQuery.matches) return;
      event.preventDefault();
      move(-1);
    });

    next.addEventListener('click', (event) => {
      if (!mediaQuery.matches) return;
      event.preventDefault();
      move(1);
    });

    gallery.addEventListener('keydown', (event) => {
      if (!mediaQuery.matches || !event.target.closest('.immershop-gallery-controls, .thumbnail')) return;
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        move(-1);
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        move(1);
      }
    });

    gallery.querySelectorAll('.thumbnail').forEach((thumbnail) => {
      thumbnail.addEventListener('click', () => window.setTimeout(syncControls));
    });

    list.addEventListener('scroll', () => window.requestAnimationFrame(syncControls), { passive: true });

    new MutationObserver(syncControls).observe(list, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
    });
    mediaQuery.addEventListener('change', syncControls);
    syncControls();
  };

  const init = (scope = document) => scope.querySelectorAll('media-gallery').forEach(enhanceGallery);

  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
